// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    category: 'Programming language',
    words: [
      {
        id: 0,
        word: 'javascript',
      },
      {
        id: 1,
        word: 'typescript',
      },
      {
        id: 2,
        word: 'java',
      },
      {
        id: 3,
        word: 'python',
      },
      {
        id: 4,
        word: 'c',
      },
      {
        id: 5,
        word: 'go',
      },
      {
        id: 6,
        word: 'php',
      },
    ], 
  },
  {
    category: 'Programming paradigm',
    words: [
      {
        id: 0,
        word: 'imperative',
      },
      {
        id: 1,
        word: 'logical',
      },
      {
        id: 2,
        word: 'functional',
      },
      {
        id: 3,
        word: 'object oriented',
      },
    ], 
  },
]